"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Milestones = exports.ALL_MILESTONES = exports.PRELUDE_TWO_MILESTONES = exports.MOON_MILESTONES = exports.ARES_MILESTONES = exports.NEW_OPS_MILESTONES = exports.UTOPIA_PLANITIA_MILESTONES = exports.AMAZONIS_PLANITIA_MILESTONES = exports.TERRA_CIMMERIA_MILESTONES = exports.ARABIA_TERRA_MILESTONES = exports.VASTITAS_BOREALIS_MILESTONES = exports.HELLAS_MILESTONES = exports.ELYSIUM_MILESTONES = exports.VENUS_MILESTONES = exports.ORIGINAL_MILESTONES = void 0;
const Terraformer_1 = require("./Terraformer");
const Mayor_1 = require("./Mayor");
const Gardener_1 = require("./Gardener");
const Builder_1 = require("./Builder");
const Planner_1 = require("./Planner");
const Hoverlord_1 = require("./Hoverlord");
const Generalist_1 = require("./Generalist");
const Specialist_1 = require("./Specialist");
const Ecologist_1 = require("./Ecologist");
const Tycoon_1 = require("./Tycoon");
const Legend_1 = require("./Legend");
const Diversifier_1 = require("./Diversifier");
const Tactician_1 = require("./Tactician");
const PolarExplorer_1 = require("./PolarExplorer");
const Energizer_1 = require("./Energizer");
const RimSettler_1 = require("./RimSettler");
const Networker_1 = require("./Networker");
const OneGiantStep_1 = require("../moon/OneGiantStep");
const Lunarchitect_1 = require("../moon/Lunarchitect");
const Electrician_1 = require("./vastitasBorealis/Electrician");
const Smith_1 = require("./vastitasBorealis/Smith");
const Irrigator_1 = require("./vastitasBorealis/Irrigator");
const Capitalist_1 = require("./vastitasBorealis/Capitalist");
const Tradesman_1 = require("./vastitasBorealis/Tradesman");
const Frontrunner_1 = require("./arabiaTerra/Frontrunner");
const Herbalist_1 = require("./arabiaTerra/Herbalist");
const Morningstar_1 = require("./arabiaTerra/Morningstar");
const Protagonist_1 = require("./arabiaTerra/Protagonist");
const Researcher_1 = require("./arabiaTerra/Researcher");
const Collector_1 = require("./terraCimmeria/Collector");
const Firestarter_1 = require("./terraCimmeria/Firestarter");
const Gambler_1 = require("./terraCimmeria/Gambler");
const Spacefarer_1 = require("./terraCimmeria/Spacefarer");
const Pioneer_1 = require("./terraCimmeria/Pioneer");
const Colonizer_1 = require("./amazonisPlanitia/Colonizer");
const Farmer_1 = require("./amazonisPlanitia/Farmer");
const Minimalist_1 = require("./amazonisPlanitia/Minimalist");
const Terran_1 = require("./amazonisPlanitia/Terran");
const Tropicalist_1 = require("./amazonisPlanitia/Tropicalist");
const Monument_1 = require("./fanmade/Monument");
const Wanderer_1 = require("./fanmade/Wanderer");
const Ambassador_1 = require("./fanmade/Ambassador");
const Passer_1 = require("./fanmade/Passer");
const Purifier_1 = require("./fanmade/Purifier");
const Maverick_1 = require("./fanmade/Maverick");
const Landshaper_1 = require("./preludeTwo/Landshaper");
const LandSpecialist_1 = require("./utopiaPlanitia/LandSpecialist");
const Sponsor_1 = require("./preludeTwo/Sponsor");
const Briber_1 = require("./preludeTwo/Briber");
const Hydrologist_1 = require("./preludeTwo/Hydrologist");
const Breeder_1 = require("./preludeTwo/Breeder");
const Fundraiser_1 = require("./preludeTwo/Fundraiser");
const Lobbyist_1 = require("./preludeTwo/Lobbyist");
const Thermodynamic_1 = require("./preludeTwo/Thermodynamic");
const Thawer_1 = require("./preludeTwo/Thawer");
const Philanthropist_1 = require("./preludeTwo/Philanthropist");
const Fabricator_1 = require("./preludeTwo/Fabricator");
const Planetologist_1 = require("./preludeTwo/Planetologist");
const Geologist_1 = require("./preludeTwo/Geologist");
const Merchant_1 = require("./preludeTwo/Merchant");
const Architect_1 = require("./preludeTwo/Architect");
exports.ORIGINAL_MILESTONES = [
    new Terraformer_1.Terraformer(),
    new Mayor_1.Mayor(),
    new Gardener_1.Gardener(),
    new Builder_1.Builder(),
    new Planner_1.Planner(),
];
exports.VENUS_MILESTONES = [
    new Hoverlord_1.Hoverlord(),
];
exports.ELYSIUM_MILESTONES = [
    new Generalist_1.Generalist(),
    new Specialist_1.Specialist(),
    new Ecologist_1.Ecologist(),
    new Tycoon_1.Tycoon(),
    new Legend_1.Legend(),
];
exports.HELLAS_MILESTONES = [
    new Diversifier_1.Diversifier(),
    new Tactician_1.Tactician(),
    new PolarExplorer_1.PolarExplorer(),
    new Energizer_1.Energizer(),
    new RimSettler_1.RimSettler(),
];
exports.VASTITAS_BOREALIS_MILESTONES = [
    new Electrician_1.Electrician(),
    new Smith_1.Smith(),
    new Tradesman_1.Tradesman(),
    new Irrigator_1.Irrigator(),
    new Capitalist_1.Capitalist(),
];
exports.ARABIA_TERRA_MILESTONES = [
    new Frontrunner_1.Frontrunner(),
    new Herbalist_1.Herbalist(),
    new Morningstar_1.Morningstar(),
    new Protagonist_1.Protagonist(),
    new Researcher_1.Researcher(),
];
exports.TERRA_CIMMERIA_MILESTONES = [
    new Collector_1.Collector(),
    new Firestarter_1.Firestarter(),
    new Pioneer_1.Pioneer(),
    new Spacefarer_1.Spacefarer(),
    new Gambler_1.Gambler(),
];
exports.AMAZONIS_PLANITIA_MILESTONES = [
    new Colonizer_1.Colonizer(),
    new Farmer_1.Farmer(),
    new Minimalist_1.Minimalist(),
    new Terran_1.Terran(),
    new Tropicalist_1.Tropicalist(),
];
exports.UTOPIA_PLANITIA_MILESTONES = [
    new LandSpecialist_1.LandSpecialist(),
    new Colonizer_1.Colonizer(),
    new Tradesman_1.Tradesman(),
    new Smith_1.Smith(),
    new Researcher_1.Researcher(),
];
exports.NEW_OPS_MILESTONES = [
    new Monument_1.Monument(),
    new Wanderer_1.Wanderer(),
    new Ambassador_1.Ambassador(),
    new Passer_1.Passer(),
    new Purifier_1.Purifier(),
    new Maverick_1.Maverick(),
];
exports.ARES_MILESTONES = [
    new Networker_1.Networker(),
];
exports.MOON_MILESTONES = [
    new OneGiantStep_1.OneGiantStep(),
    new Lunarchitect_1.Lunarchitect(),
];
exports.PRELUDE_TWO_MILESTONES = [
    new Architect_1.Architect(),
    new Breeder_1.Breeder(),
    new Briber_1.Briber(),
    new Fabricator_1.Fabricator(),
    new Fundraiser_1.Fundraiser(),
    new Geologist_1.Geologist(),
    new Hydrologist_1.Hydrologist(),
    new Landshaper_1.Landshaper(),
    new Lobbyist_1.Lobbyist(),
    new Merchant_1.Merchant(),
    new Philanthropist_1.Philanthropist(),
    new Planetologist_1.Planetologist(),
    new Sponsor_1.Sponsor(),
    new Thawer_1.Thawer(),
    new Thermodynamic_1.Thermodynamic(),
];
exports.ALL_MILESTONES = Array.from(new Set([
    ...exports.ORIGINAL_MILESTONES,
    ...exports.ELYSIUM_MILESTONES,
    ...exports.HELLAS_MILESTONES,
    ...exports.VASTITAS_BOREALIS_MILESTONES,
    ...exports.ARABIA_TERRA_MILESTONES,
    ...exports.TERRA_CIMMERIA_MILESTONES,
    ...exports.AMAZONIS_PLANITIA_MILESTONES,
    ...exports.UTOPIA_PLANITIA_MILESTONES,
    ...exports.NEW_OPS_MILESTONES,
    ...exports.VENUS_MILESTONES,
    ...exports.ARES_MILESTONES,
    ...exports.MOON_MILESTONES,
    ...exports.PRELUDE_TWO_MILESTONES,
]));
var Milestones;
(function (Milestones) {
    Milestones.ALL = exports.ALL_MILESTONES;
    function getByName(name) {
        const milestone = exports.ALL_MILESTONES.find((m) => m.name === name);
        if (milestone) {
            return milestone;
        }
        throw new Error(`Milestone ${name} not found.`);
    }
    Milestones.getByName = getByName;
})(Milestones = exports.Milestones || (exports.Milestones = {}));
//# sourceMappingURL=Milestones.js.map